import { MemberAuthenticationGrantType } from '@vista-digital/ocapi-types/v1';
import { OcapiError } from '../../../../types/ocapi-error';
import { getResponseErrorCode } from '../../../../utils/get-response-error-code';
import { getResponseErrorStatusCode } from '../../../../utils/get-response-error-status-code';
/**
 * Authentication error of sign in
 */
export var SignInErrorCodeV1;
(function (SignInErrorCodeV1) {
    /**
     * Incorrect credentials error of failed sign in.
     */
    SignInErrorCodeV1[SignInErrorCodeV1["InvalidCredentials"] = 100] = "InvalidCredentials";
    /**
     * The existing refresh token has expired.
     */
    SignInErrorCodeV1[SignInErrorCodeV1["RefreshTokenExpired"] = 101] = "RefreshTokenExpired";
    /**
     * Represents a loyalty member temporarily locked out of loyalty due to too many failed login attempts.
     */
    SignInErrorCodeV1[SignInErrorCodeV1["MemberLocked"] = 32000] = "MemberLocked";
    /**
     * Represents a device temporarily locked out of loyalty due to too many login attempts.
     */
    SignInErrorCodeV1[SignInErrorCodeV1["DeviceLocked"] = 32001] = "DeviceLocked";
})(SignInErrorCodeV1 || (SignInErrorCodeV1 = {}));
export class SignInErrorV1 extends OcapiError {
    constructor(errorCode) {
        const message = `Failed to sign in. API error code ${errorCode}: ${SignInErrorCodeV1[errorCode]}`;
        super(errorCode, message);
    }
}
export async function getSignInErrorV1(error, authenticationGrantType) {
    const statusCode = getResponseErrorStatusCode(error);
    const errorCode = await getResponseErrorCode(error);
    if (statusCode === 400) {
        const signInErrorCode = errorCode && Object.values(SignInErrorCodeV1).includes(errorCode)
            ? errorCode
            : SignInErrorCodeV1.InvalidCredentials;
        return new SignInErrorV1(signInErrorCode);
    }
    if (statusCode === 401 && authenticationGrantType === MemberAuthenticationGrantType.RefreshToken) {
        return new SignInErrorV1(SignInErrorCodeV1.RefreshTokenExpired);
    }
    return error;
}
//# sourceMappingURL=sign-in-error.js.map